<template>
  <div class="dialog-wrap">
    <el-dialog
      title="收益分成"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="560px"
    >
      <el-form
        class="form"
        :model="dataForm"
        ref="dataForm"
        label-width="90px"
      >
        <el-form-item label="商品类型：">
          <el-select
            v-model="product_type"
            clearable
            placeholder="请选择"
          >
            <el-option
              label="课程"
              :value="1"
            >
            </el-option>
            <el-option
              label="题库"
              :value="2"
            >
            </el-option>
            <el-option
              label="专栏"
              :value="3"
            >
            </el-option>
            <el-option
              label="资料"
              :value="4"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="选择商品："
          prop="product_name"
        >
          <el-input
            :value="dataForm.product_name"
            placeholder="选择商品"
            suffix-icon="el-icon-search"
            @focus="handleProductChoose"
          >
          </el-input>
        </el-form-item>
        <div style="display:flex;">
          <el-form-item
            label="佣金比例："
            prop="charge_rate"
          >
            <el-input
              v-model="dataForm.charge_rate"
              placeholder="请输入佣金比例"
            >
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item
            label="佣金金额："
            prop="charge_amount"
            style="margin-left:16px;"
          >
            <el-input
              v-model="dataForm.charge_amount"
              placeholder="请输入佣金金额"
            > <template slot="append">元</template></el-input>
          </el-form-item>
        </div>
        <el-form-item label="推广文案：">
          <el-input
            type="textarea"
            placeholder="请输入内容"
            v-model="dataForm.promoter_desc"
            :rows="3"
            :limit="9"
          >
          </el-input>

        </el-form-item>
        <el-form-item label="推广图片：">
          <el-upload
            action="http://test-api.kaoyanbox.net/api/v1/back/upload/image"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-success="handleSuccess"
            :file-list="fileList"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          type="primary"
          @click="handleSubmit"
        >确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="imgVisible">
      <img
        width="100%"
        :src="dialogImageUrl"
        alt=""
      >
    </el-dialog>
    <ProductChoose
      :visible="ProductChooseDialog"
      @close="ProductChooseDialog = false"
      @submit="saveGood"
      :ref_type="product_type"
    ></ProductChoose>
  </div>
</template>

<script>
import { authorChargeCreate } from "@/api/seniorprofit";
import ProductChoose from "@/components/dialog/ContentChoose";
export default {
  components: {
    ProductChoose
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: () => { return {} }
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: this.content,
      imgVisible: false,
      dialogImageUrl: '',
      fileList: [],
      product_type: 1,
      ProductChooseDialog: false,
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    content(val) {
      this.dataForm = val
      let arr = val.promoter_img_urls ? val.promoter_img_urls.split(',') : []
      this.fileList = arr.map((v) => {
        return {
          url: v
        }
      })
    }
  },
  methods: {
    handleProductChoose() {
      this.ProductChooseDialog = true
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.fileList = fileList
    },
    handleSuccess(response, file, fileList) {
      this.fileList.push({
        url: response.data.url
      })
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.imgVisible = true;
    },
    handleClose() {
      this.dataForm = {}
      this.fileList = []
      this.$emit('close')
    },
    saveGood(val) {
      this.dataForm.product_id = val.id
      this.dataForm.product_name = val.name
    },
    handleSubmit() {
      let arr = this.fileList.map((v) => { return v.url })
      delete this.dataForm.product_name
      this.dataForm.charge_rate = Number(this.dataForm.charge_rate) / 100
      /*  this.dataForm.charge_amount = Number(this.dataForm.charge_amount) */
      const param = Object.assign({}, this.dataForm, {
        promoter_img_urls: arr.join(','),
      })
      if (param.charge_amount) {
        param.charge_amount = Number(param.charge_amount) / 100
      } else {
        delete param.charge_amount
      }

      authorChargeCreate(param).then(res => {
        this.$message.success(`创建成功`)
        this.$refs['dataForm'].resetFields()
        this.$emit('submit')
        this.handleClose()
      }).catch(error => {
       /*  this.$message.error(`此商品已经创建，请重新选择商品`) */
      })
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-wrap {
}
/deep/.el-upload {
  width: 122px;
  height: 122px;
  line-height: 122px;
}
/deep/.el-upload-list__item {
  width: 122px;
  height: 122px;
}
</style>
